import React from 'react';
import SectionHeading from './ui/SectionHeading';

function AboutUs() {
  return (
    <section className="bg-slate-50 py-16 md:py-24" id="about-us" aria-labelledby="about-heading">
      <div className="mx-auto max-w-7xl px-6">
        <SectionHeading
          id="about-heading"
          eyebrow="Our practice"
          title="About us"
          subtitle="We combine clinical excellence with a welcoming, no-pressure shopping experience — so you leave seeing better and feeling confident."
        />

        <div className="mx-auto max-w-3xl text-center text-lg leading-relaxed text-slate-600">
          <p>
            At Vision World Albertson, we are committed to providing top-quality eye care services and a wide range of
            stylish eyewear. Our dedicated team works tirelessly to ensure each customer finds the perfect pair of
            glasses that suits their lifestyle and needs.
          </p>
        </div>

        <figure className="mt-12">
          <img
            src="/photos/team-photo.jpeg"
            alt="Vision World Albertson staff welcoming customers at the optical boutique"
            className="mx-auto w-full max-w-4xl rounded-2xl border border-slate-100 object-cover shadow-card"
            loading="lazy"
          />
          <figcaption className="mt-3 text-center text-sm text-slate-500">Our team — here for your vision and style.</figcaption>
        </figure>

        <div className="mx-auto mt-12 max-w-3xl space-y-6 text-center text-lg leading-relaxed text-slate-600">
          <p>
            Our expert optometrists and friendly staff are here to help you every step of the way. Whether you need an
            eye exam, a contact lens fitting, or the latest in designer eyewear, we&apos;re your go-to destination for all
            things vision.
          </p>
          <p className="font-medium text-slate-800">Visit us today and experience our commitment to excellence.</p>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
